<template>
  <v-card>
    <v-card-title>
      <span class="headline">Fondo Caja</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="monto"
              label="Monto del fondo para la caja*"
              hint="cantidad que dejas para cambio en la caja"
              type="number" 
              outlined 
              autofocus
              placeholder="0"
              persistent-hint
              class="text-h4 font-weight-black"
              prepend-inner-icon="mdi-currency-usd"
              :disabled="fondo?true:false"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <!-- <small>*campos requeridos</small> -->
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="default" text @click="cancel">
        Cancelar
      </v-btn>
      <v-btn color="blue darken-1" text :disabled="!monto" @click="saveFondo"> Guardar </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// const { getFondoCaja, registrarFondoCaja } = api.services.cajaService; 
export default {
  name: "FondoCaja",
  data(){
    return {
      fondo: this.getFondoCaja() || null,
      monto: null,
    };
  },
  computed:{
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['closeCajaModal']),
    getFondoCaja(){},
    registrarFondoCaja(){},
    saveFondo(){
      const monto = this.monto;
      const idUsuario = this.user.id;
      const result = this.registrarFondoCaja(monto, idUsuario);
      if (result) {
        this.closeCajaModal();
        this.$emit('new-fondo-added');
        this.resetFCData();
      }
    },
    resetFCData(){
      this.fondo = this.getFondoCaja() || null;
      this.monto = null;
    },
    cancel(){
      this.resetFCData();
      this.$emit('close-caja-modal');
    }
  }
}
</script>